import * as React from "react";
import { Redirect, useParams } from "react-router";

import { detailUrl } from "../../../store/invoicingCostCenters";

export default function InvoicingCostCenterRedirect() {
  const { id } = useParams();

  // wait for sufficient data to redirect
  if (!id) return null;

  return <Redirect to={detailUrl({ id })} />;
}
